import _JSXStyle from "styled-jsx/style";
import { spacers } from '@dhis2/ui-constants';
import PropTypes from 'prop-types';
import React from 'react';
export const Icon = _ref => {
  let {
    icon,
    dataTest
  } = _ref;

  if (!icon) {
    return null;
  }

  return /*#__PURE__*/React.createElement("span", {
    "data-test": dataTest,
    className: _JSXStyle.dynamic([["1889825154", [spacers.dp4]]])
  }, icon, /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "1889825154",
    dynamic: [spacers.dp4]
  }, ["span.__jsx-style-dynamic-selector{width:24px;height:24px;margin-inline-start:".concat(spacers.dp4, ";margin-inline-end:-6px;border-radius:50%;overflow:hidden;}"), "span.__jsx-style-dynamic-selector>*{max-height:24px;max-width:24px;}"]));
};
Icon.propTypes = {
  dataTest: PropTypes.string.isRequired,

  /** the slot for an icon is 24x24px, bigger elements will be clipped */
  icon: PropTypes.element
};